{
  "items": {
    "rusty_sword": "Paslı Kılıç",
    "iron_sword": "Demir Kılıç",
    "iron_hatchet": "Demir Balta",
    "worn_daggers": "Yıpranmış Hançerler",
    "iron_daggers": "Demir Hançerler",
    "ash_staff": "Dişbudak Asa",
    "oak_staff": "Meşe Asa",
    "wooden_mace": "Tahta Topuz",
    "iron_mace": "Demir Topuz",
    "wooden_shield": "Tahta Kalkan",
    "iron_shield": "Demir Kalkan",
    "leather_cap": "Deri Başlık",
    "padded_vest": "Kapitone Yelek",
    "leather_gloves": "Deri Eldiven",
    "leather_boots": "Deri Çizme",
    "iron_helm": "Demir Miğfer",
    "chain_vest": "Zincir Zırh",
    "iron_gauntlets": "Demir Eldiven",
    "iron_boots": "Demir Çizme",
    "copper_ring": "Bakır Yüzük",
    "bone_necklace": "Kemik Kolye",
    "minor_hp_potion": "Küçük Can İksiri",
    "minor_mp_potion": "Küçük Mana İksiri",
    "boar_hide": "Domuz Postu",
    "wolf_fang": "Kurt Dişi",
    "toad_slime": "Kurbağa Balçığı",
    "husk_stone": "Kabuk Taşı",
    "upgrade_scroll": "Yükseltme Kağıdı",
    "colony_scroll": "En İyi Yükseltme Kağıdı",
    "jewelry_scroll": "Takı Kağıdı",
    "fortune_stone": "Şans Taşı",
    "market_scroll": "Pazar Kağıdı",
    "steel_sword": "Çelik Kılıç",
    "steel_falchion": "Çelik Pala",
    "steel_daggers": "Çelik Hançerler",
    "steel_venom_daggers": "Zehirli Hançerler",
    "steel_staff": "Demirağaç Asa",
    "steel_mace": "Çelik Topuz",
    "steel_shield": "Çelik Kalkan",
    "steel_helm": "Çelik Miğfer",
    "steel_plate": "Çelik Göğüslük",
    "steel_gauntlets": "Çelik Eldiven",
    "steel_boots": "Çelik Çizme",
    "mithril_sword": "Mithril Kılıç",
    "mithril_waraxe": "Mithril Savaş Baltası",
    "mithril_daggers": "Mithril Hançerler",
    "mithril_rime_daggers": "Kırağı Hançerleri",
    "mithril_staff": "Mithril Asa",
    "mithril_mace": "Mithril Topuz",
    "mithril_shield": "Mithril Kalkan",
    "mithril_helm": "Mithril Miğfer",
    "mithril_plate": "Mithril Göğüslük",
    "mithril_gauntlets": "Mithril Eldiven",
    "mithril_boots": "Mithril Çizme",
    "dragon_sword": "Ejder Kılıcı",
    "dragon_wingblade": "Ejder Kanatkılıcı",
    "dragon_scythe": "Ejder Tırpanı",
    "dragon_daggers": "Ejder Hançerleri",
    "dragon_storm_daggers": "Fırtınadiş Hançerleri",
    "dragon_staff": "Ejderkemiği Asa",
    "dragon_mace": "Ejder Topuzu",
    "dragon_shield": "Ejder Kalkanı",
    "dragon_helm": "Ejder Miğferi",
    "dragon_plate": "Ejder Göğüslüğü",
    "dragon_gauntlets": "Ejder Eldiveni",
    "dragon_boots": "Ejder Çizmesi",
    "silver_ring": "Gümüş Yüzük",
    "moonstone_amulet": "Aytaşı Muska",
    "warlord_signet": "Savaş Beyi Mühürlü Yüzüğü",
    "bear_pelt": "Ayı Postu",
    "troll_tusk": "Trol Dişi",
    "ember_core": "Köz Çekirdeği",
    "leather_belt": "Deri Kemer",
    "garnet_stud": "Lal Küpe",
    "iron_girdle": "Demir Kuşak",
    "obsidian_hoop": "Obsidyen Halka Küpe",
    "emberbound_belt": "Köz Bağlı Kemer",
    "frostbound_belt": "Ayaz Bağlı Kemer",
    "stormbound_belt": "Fırtına Bağlı Kemer",
    "earring_of_the_vanguard": "Öncü Küpesi",
    "earring_of_the_shadow": "Gölge Küpesi",
    "earring_of_the_arcanist": "Arkanist Küpesi",
    "earring_of_the_devout": "Dindar Küpesi",
    "ashdrake_pendant": "Kül Ejderi Kolyesi",
    "frostdrake_pendant": "Ayaz Ejderi Kolyesi",
    "stormdrake_pendant": "Fırtına Ejderi Kolyesi",
    "bloodstone_ring": "Kantaşı Yüzük",
    "moonglass_ring": "Aycamı Yüzük",
    "heart_of_the_colossus": "Dev'in Kalbi",
    "cloak_of_the_vanguard": "Öncü Pelerini",
    "cloak_of_the_blooded": "Kanlıların Pelerini",
    "cloak_of_the_champion": "Şampiyon Pelerini",
    "cloak_of_the_paragon": "Kusursuzlar Pelerini",
    "azure_glow": "Mavi Işıltı",
    "solar_glow": "Güneş Işıltısı",
    "ember_glow": "Köz Işıltısı",
    "verdant_glow": "Yeşil Işıltı",
    "violet_glow": "Mor Işıltı",
    "prism_glow": "Prizma Işıltısı",
    "hellmaw_cleaver": "Hellmaw Satırı",
    "fangs_of_hellmaw": "Hellmaw'ın Dişleri",
    "staff_of_the_old_root": "Kadim Kök Asası",
    "hollowbell_mace": "Boşçan Topuzu",
    "heartsplitter": "Nightreaper",
    "duskreaver_daggers": "Alacakaranlık Hançerleri",
    "staff_of_the_sundered_sky": "Yarılmış Gök Asası",
    "crownforge_maul": "Taçdemir Gürzü",
    "old_tusks_charm": "Old Tusk'ın Tılsımı",
    "barrow_crown_ring": "Höyük Tacı Yüzüğü",
    "grave_warden_earring": "Mezar Bekçisi Küpesi",
    "mossback_hide_belt": "Mossback Postu Kemer",
    "tyrants_ember": "Tiranın Közü",
    "hellmaw_fang_necklace": "Hellmaw Dişi Kolye",
    "wisp_azure": "Mavi Işık Ruhu",
    "wisp_solar": "Güneş Işık Ruhu",
    "wisp_ember": "Köz Işık Ruhu",
    "wisp_verdant": "Yeşil Işık Ruhu",
    "wisp_violet": "Mor Işık Ruhu",
    "wisp_prism": "Prizma Işık Ruhu",
    "gold_bar": "Altın Külçe",
    "riftstone_green": "Yeşil Yarık Taşı",
    "riftstone_blue": "Mavi Yarık Taşı",
    "riftstone_violet": "Mor Yarık Taşı",
    "wyrmwing_cloak": "Ejderkanat Pelerini",
    "wings_dawnfeather": "Şafaktüyü Kanatları",
    "wings_seraph": "Melek Kanatları",
    "wings_sovereign": "Hükümdar Kanatları",
    "wings_aurelian": "Altın Kanatlar",
    "wings_emberdrake": "Köz Ejderi Kanatları",
    "wings_phoenix": "Anka Kanatları",
    "wings_nightshade": "Gece Gölgesi Kanatları",
    "wings_moonveil": "Ay Tülü Kanatları",
    "wings_frostveil": "Ayaz Tülü Kanatları",
    "clan_cloak_banner": "Klan Sancak Pelerini",
    "clan_cloak_warden": "Klan Muhafız Pelerini",
    "clan_cloak_sovereign": "Klan Hükümdar Pelerini",
    "hp_scroll": "HP Kağıdı +2000",
    "speed_scroll": "Hız Kağıdı +%55",
    "defense_scroll": "Savunma Kağıdı +350",
    "attack_scroll": "Saldırı Kağıdı +100",
    "novice_xp_scroll": "Acemi XP Kağıdı +%30",
    "novice_gold_scroll": "Acemi Altın Kağıdı +%10",
    "novice_speed_scroll": "Acemi Hız Kağıdı +%55",
    "novice_hp_scroll": "Acemi HP Kağıdı +300",
    "novice_defense_scroll": "Acemi Savunma Kağıdı +30",
    "novice_attack_scroll": "Acemi Saldırı Kağıdı +20",
    "bronze_band": "Bronz Yüzük",
    "sage_charm": "Bilge Tılsımı",
    "hunters_earring": "Avcı Küpesi",
    "warders_belt": "Bekçi Kemeri",
    "flameheart_ring": "Alevkalp Yüzüğü",
    "stormglass_earring": "Fırtınacamı Küpe",
    "riftshard_ring": "Yarık Kırığı Yüzük",
    "riftshard_earring": "Yarık Kırığı Küpe",
    "riftbound_earring": "Yarık Bağlı Küpe",
    "riftbound_belt": "Yarık Bağlı Kemer",
    "riftcrown_pendant": "Yarık Tacı Kolyesi",
    "riftwalker_cloak": "Yarık Gezgini Pelerini",
    "hide_hood": "Post Kukuleta",
    "hide_jerkin": "Post Yelek",
    "hide_grips": "Post Eldiven",
    "hide_treads": "Post Çizme",
    "stalker_hood": "İzci Kukuleta",
    "stalker_jerkin": "İzci Yelek",
    "stalker_grips": "İzci Eldiven",
    "stalker_treads": "İzci Çizme",
    "nightveil_hood": "Gecetülü Kukuleta",
    "nightveil_jerkin": "Gecetülü Yelek",
    "nightveil_grips": "Gecetülü Eldiven",
    "nightveil_treads": "Gecetülü Çizme",
    "drakescale_hood": "Ejder Pulu Kukuleta",
    "drakescale_jerkin": "Ejder Pulu Yelek",
    "drakescale_grips": "Ejder Pulu Eldiven",
    "drakescale_treads": "Ejder Pulu Çizme",
    "linen_hat": "Keten Şapka",
    "linen_robe": "Keten Cübbe",
    "linen_wraps": "Keten Sargı",
    "linen_slippers": "Keten Terlik",
    "silkweave_hat": "İpek Dokuma Şapka",
    "silkweave_robe": "İpek Dokuma Cübbe",
    "silkweave_wraps": "İpek Dokuma Sargı",
    "silkweave_slippers": "İpek Dokuma Terlik",
    "moonsilk_hat": "Ay İpeği Şapka",
    "moonsilk_robe": "Ay İpeği Cübbe",
    "moonsilk_wraps": "Ay İpeği Sargı",
    "moonsilk_slippers": "Ay İpeği Terlik",
    "emberweave_hat": "Kor Dokuma Şapka",
    "emberweave_robe": "Kor Dokuma Cübbe",
    "emberweave_wraps": "Kor Dokuma Sargı",
    "emberweave_slippers": "Kor Dokuma Terlik",
    "acolyte_circlet": "Mürit Taç",
    "acolyte_vestment": "Mürit Kaftan",
    "acolyte_gloves": "Mürit Eldiven",
    "acolyte_boots": "Mürit Çizme",
    "cleric_circlet": "Rahip Taç",
    "cleric_vestment": "Rahip Kaftan",
    "cleric_gloves": "Rahip Eldiven",
    "cleric_boots": "Rahip Çizme",
    "sanctified_circlet": "Kutsal Taç",
    "sanctified_vestment": "Kutsal Kaftan",
    "sanctified_gloves": "Kutsal Eldiven",
    "sanctified_boots": "Kutsal Çizme",
    "dawnforged_circlet": "Şafakdöven Taç",
    "dawnforged_vestment": "Şafakdöven Kaftan",
    "dawnforged_gloves": "Şafakdöven Eldiven",
    "dawnforged_boots": "Şafakdöven Çizme",
    "titan_sword": "Titan Kılıcı",
    "titan_greataxe": "Titan Baltası",
    "phantom_daggers": "Hayalet Hançerler",
    "astral_staff": "Yıldız Asası",
    "seraphic_mace": "Melek Topuzu",
    "titan_shield": "Titan Kalkanı",
    "titan_helm": "Titan Miğferi",
    "titan_plate": "Titan Göğüslüğü",
    "titan_gauntlets": "Titan Eldiveni",
    "titan_boots": "Titan Çizmesi",
    "phantom_hood": "Hayalet Kukuleta",
    "phantom_jerkin": "Hayalet Yelek",
    "phantom_grips": "Hayalet Eldiven",
    "phantom_treads": "Hayalet Çizme",
    "astral_hat": "Yıldız Şapka",
    "astral_robe": "Yıldız Cübbe",
    "astral_wraps": "Yıldız Sargı",
    "astral_slippers": "Yıldız Terlik",
    "seraphic_circlet": "Melek Tacı",
    "seraphic_vestment": "Melek Kaftanı",
    "seraphic_gloves": "Melek Eldiveni",
    "seraphic_boots": "Melek Çizmesi",
    "bronze_ring_might": "Bronz Güç Yüzüğü",
    "bronze_ring_swift": "Bronz Çeviklik Yüzüğü",
    "bronze_ring_arcane": "Bronz Büyü Yüzüğü",
    "bronze_ring_ward": "Bronz Koruma Yüzüğü",
    "bronze_neck_might": "Bronz Güç Muskası",
    "bronze_neck_swift": "Bronz Çeviklik Muskası",
    "bronze_neck_arcane": "Bronz Büyü Muskası",
    "bronze_neck_ward": "Bronz Koruma Muskası",
    "bronze_earring_might": "Bronz Güç Küpesi",
    "bronze_earring_swift": "Bronz Çeviklik Küpesi",
    "bronze_earring_arcane": "Bronz Büyü Küpesi",
    "bronze_earring_ward": "Bronz Koruma Küpesi",
    "bronze_belt_might": "Bronz Güç Kemeri",
    "bronze_belt_swift": "Bronz Çeviklik Kemeri",
    "bronze_belt_arcane": "Bronz Büyü Kemeri",
    "bronze_belt_ward": "Bronz Koruma Kemeri",
    "silver_ring_might": "Gümüş Güç Yüzüğü",
    "silver_ring_swift": "Gümüş Çeviklik Yüzüğü",
    "silver_ring_arcane": "Gümüş Büyü Yüzüğü",
    "silver_ring_ward": "Gümüş Koruma Yüzüğü",
    "silver_neck_might": "Gümüş Güç Muskası",
    "silver_neck_swift": "Gümüş Çeviklik Muskası",
    "silver_neck_arcane": "Gümüş Büyü Muskası",
    "silver_neck_ward": "Gümüş Koruma Muskası",
    "silver_earring_might": "Gümüş Güç Küpesi",
    "silver_earring_swift": "Gümüş Çeviklik Küpesi",
    "silver_earring_arcane": "Gümüş Büyü Küpesi",
    "silver_earring_ward": "Gümüş Koruma Küpesi",
    "silver_belt_might": "Gümüş Güç Kemeri",
    "silver_belt_swift": "Gümüş Çeviklik Kemeri",
    "silver_belt_arcane": "Gümüş Büyü Kemeri",
    "silver_belt_ward": "Gümüş Koruma Kemeri",
    "gold_ring_might": "Altın Güç Yüzüğü",
    "gold_ring_swift": "Altın Çeviklik Yüzüğü",
    "gold_ring_arcane": "Altın Büyü Yüzüğü",
    "gold_ring_ward": "Altın Koruma Yüzüğü",
    "gold_neck_might": "Altın Güç Muskası",
    "gold_neck_swift": "Altın Çeviklik Muskası",
    "gold_neck_arcane": "Altın Büyü Muskası",
    "gold_neck_ward": "Altın Koruma Muskası",
    "gold_earring_might": "Altın Güç Küpesi",
    "gold_earring_swift": "Altın Çeviklik Küpesi",
    "gold_earring_arcane": "Altın Büyü Küpesi",
    "gold_earring_ward": "Altın Koruma Küpesi",
    "gold_belt_might": "Altın Güç Kemeri",
    "gold_belt_swift": "Altın Çeviklik Kemeri",
    "gold_belt_arcane": "Altın Büyü Kemeri",
    "gold_belt_ward": "Altın Koruma Kemeri",
    "legion_belt": "Lejyon Kemeri",
    "mantle_lionheart": "Aslanyürek Mantosu",
    "mantle_starweave": "Yıldız Dokuma Pelerin",
    "mantle_emberwake": "Köz İzi Pelerini",
    "mantle_wildheart": "Yabanyürek Mantosu",
    "whitecrown_mantle": "Beyaz Taç Pelerini",
    "race_change_scroll": "Öteki Sancak Kağıdı",
    "gender_change_scroll": "Öteki Ben Kağıdı",
    "sapphire_coffer": "Safir Sandık",
    "jade_coffer": "Yeşim Sandık",
    "greater_sapphire_coffer": "Büyük Safir Sandık",
    "greater_jade_coffer": "Büyük Yeşim Sandık"
  },
  "mobs": {
    "training_dummy": "Antrenman Kuklası",
    "bristle_boar": "Kıllı Yaban Domuzu",
    "ash_wolf": "Kül Kurdu",
    "mire_toad": "Bataklık Kurbağası",
    "stone_husk": "Taş Kabuk",
    "thornback_boar": "Dikensırt Domuz",
    "bandit": "Haydut",
    "alpha_wolf": "Alfa Kurt",
    "mire_lurker": "Bataklık Pusucusu",
    "barrow_skeleton": "Höyük İskeleti",
    "cave_bear": "Mağara Ayısı",
    "forest_troll": "Orman Trolü",
    "granite_golem": "Granit Golem",
    "dire_wolf": "Vahşi Kurt",
    "ogre_brute": "Kaba Ogre",
    "ash_revenant": "Kül Hortlağı",
    "hellhound": "Cehennem Tazısı",
    "obsidian_golem": "Obsidyen Golem",
    "cinder_warden": "Kor Muhafızı",
    "magma_behemoth": "Magma Devi",
    "gloom_stalker": "Kasvet Avcısı",
    "old_tusk": "Old Tusk",
    "barrow_king": "Höyük Kralı",
    "mossback": "Kadim Mossback",
    "cinder_tyrant": "Kor Tiranı",
    "hellmaw": "Hellmaw",
    "grak_warlord": "Savaş Beyi Grak",
    "ancient_colossus": "Kadim Dev",
    "gnarlhide": "Gnarlhide",
    "redmane": "Redmane",
    "grimtusk": "Grimtusk",
    "bonecaller": "Kemik Çağıran",
    "rift_shade": "Umbral Gölgesi",
    "duskbound_sentinel": "Alacakaranlık Nöbetçisi",
    "voidstone_golem": "Boşluktaşı Golem",
    "riftborn_stalker": "Yarıkdoğan Avcı",
    "cinder_wyrm": "Kor Ejderi Skorvyn",
    "ashen_gladiator": "Kül İğnesi",
    "crown_champion": "Taç Şampiyonu",
    "rimefang_wolf": "Kırağıdiş Kurt",
    "rime_golem": "Kırağı Golem",
    "hoarfrost_titan": "Kırağı Titanı",
    "magma_toad": "Magma Kurbağası",
    "slag_brute": "Cüruf Canavarı",
    "pyreheart": "Pyreheart",
    "war_keeper_human": "Valcrest Savaş Bekçisi",
    "war_keeper_orc": "Gorzhak Savaş Bekçisi",
    "event_frostbeard": "Ayaz Sakal Dede",
    "event_gilded_imp": "Yaldızlı İblisçik",
    "clash_crystal": "Çatışma Kristali",
    "greater_clash_crystal": "Büyük Çatışma Kristali"
  },
  "skills": {
    "warrior_cleave": "Ağır Darbe",
    "warrior_shield_bash": "Kalkan Vuruşu",
    "warrior_war_cry": "Savaş Narası",
    "warrior_charge": "Hücum",
    "warrior_iron_skin": "Demir Deri",
    "warrior_sprint": "Koşu",
    "rogue_twin_strike": "İkiz Darbe",
    "rogue_venom_blade": "Zehirli Bıçak",
    "rogue_shadow_step": "Gölge Adımı",
    "rogue_hamstring": "Topuk Kesme",
    "rogue_ambush": "Pusu",
    "rogue_swift": "Çeviklik",
    "mage_firebolt": "Ateş Oku",
    "mage_frost_nova": "Ayaz Isırığı",
    "mage_blink": "Işınlanma",
    "mage_meteor": "Meteor",
    "mage_sprint": "Koşu",
    "priest_smite": "İlahi Darbe",
    "priest_mend": "Onarma",
    "priest_blessing": "Kutsama",
    "priest_sprint": "Koşu",
    "warrior_sunder": "Zırh Parçalama",
    "warrior_execute": "Cellat Darbesi",
    "rogue_crippling_venom": "Sakatlayan Zehir",
    "rogue_blade_flurry": "Bıçak Fırtınası",
    "mage_flame_wave": "Alev Dalgası",
    "mage_cataclysm": "Kıyamet",
    "priest_prayer": "Şifa Duası",
    "priest_judgment": "Hüküm",
    "priest_purify": "Arındırma",
    "rogue_shake_off": "Silkinme",
    "mage_arcane_recall": "Gizemli Dönüş",
    "mage_glacier": "Buzul",
    "priest_plague": "Veba",
    "priest_cure_all": "Tam Arınma",
    "warrior_rose_blade": "Gül Kılıcı",
    "priest_radiant_strike": "Işıltılı Darbe"
  },
  "classes": {
    "warrior": {
      "name": "Savaşçı"
    },
    "rogue": {
      "name": "Suikastçı"
    },
    "mage": {
      "name": "Büyücü"
    },
    "priest": {
      "name": "Rahip"
    }
  },
  "zones": {
    "dev_field": "Hearthmoor",
    "human_homeland": "Valcrest",
    "orc_homeland": "Gorzhak",
    "colony_zone": "Koloni Bölgesi",
    "umbral_rift": "Umbral Yarığı",
    "morgard": "Morgard",
    "crystal_clash_1": "Kristal Çatışması",
    "crystal_clash_2": "Kristal Çatışması"
  },
  "npcs": {
    "oswin": {
      "title": "Tüccar",
      "greeting": "Sağlam çelik, kaliteli deri. Buyur bir bak."
    },
    "ilsa": {
      "title": "Katip",
      "greeting": "Her kağıt elle yazılır, altın külçeler de tacın mührüyle basılır. Lekelere aldırma."
    },
    "brann": {
      "title": "Demirci",
      "greeting": "Bana çelik ve kağıt getir. Gerisine örs karar verir."
    },
    "corvin": {
      "title": "Tüccar",
      "greeting": "Taç mühürlü mallar, adil fiyatlar."
    },
    "wendell": {
      "title": "Katip",
      "greeting": "Demirhane için kağıtlar, servet taşıyanlar için altın külçeler."
    },
    "throk": {
      "title": "Tüccar",
      "greeting": "Ödersin, alırsın. Bu kadar basit."
    },
    "vashka": {
      "title": "Katip",
      "greeting": "Kan mürekkebiyle yazılmış kağıtlar, her kılıca yeter. Parası olana altın külçe de var."
    },
    "bren": {
      "title": "Levazımcı",
      "greeting": "Puanlarını sahada mı kazandın? O zaman onlara layık bir pelerin seç."
    },
    "uzga": {
      "title": "Levazımcı",
      "greeting": "Burada kumaşı kan satın alır. Neler kazandığını göster bakalım."
    },
    "garrick": {
      "title": "Depo",
      "greeting": "Bana bırak. Rafımdan hiçbir şey kaybolmaz."
    },
    "ysolde": {
      "title": "Depo",
      "greeting": "Eşyaların burada güvende, tacın kendi kasalarında mühürlü."
    },
    "morga": {
      "title": "Depo",
      "greeting": "Yığına koy. Morga neyin senin olduğunu unutmaz."
    },
    "nessa": {
      "title": "Taş Ustası",
      "greeting": "Umbral Yarığı'ndan Yarık Taşı mı getirdin? Çarkımda kır, bakalım ne çıkacak. Bazen hiçbir şey, bazen bir servet."
    },
    "hollin": {
      "title": "Yarık Tüccarı",
      "greeting": "Buradan kasabaya dönüş uzun. Taşıyamadıklarını ben alırım."
    },
    "grasha": {
      "title": "Yarık Tüccarı",
      "greeting": "Karanlığın ganimeti mi? Buraya koy, paran iyi."
    },
    "edra": {
      "title": "Klan Kahyası",
      "greeting": "Bir klan renklerini savaş meydanında kazanır. Dereceni göster, seni onlarla giydireyim."
    },
    "borgash": {
      "title": "Klan Kahyası",
      "greeting": "Klanın adı için kan mı döktü? O zaman o adı taşıyabilir."
    },
    "maren": {
      "title": "Katip",
      "greeting": "Burada mürekkep çabuk kurur. Kağıdını Gorzhak'tan önce oku."
    },
    "grisha": {
      "title": "Katip",
      "greeting": "Cephe için kağıtlar. Öde, oku, git bir şeyler kır."
    },
    "tolwen": {
      "title": "Katip",
      "greeting": "Savaş için: Bekçi düşene kadar seni ayakta tutacak kağıtlar."
    },
    "hrask": {
      "title": "Katip",
      "greeting": "Bekçi çıplak elle düşmez. Bir kağıt al."
    },
    "sethra": {
      "title": "Yarık Katibi",
      "greeting": "Yarık dikkatsizleri yutar. Dışarı çıkmadan bir kağıt oku."
    },
    "kurzog": {
      "title": "Yarık Katibi",
      "greeting": "Burada gölgeler sert vurur. Gücü sayfa sayfa satın al."
    },
    "aldric": {
      "title": "Şampiyonlar Habercisi",
      "greeting": "Ulusuna önderlik eden her ismi kitabıma yazarım. Seninki birinciyse, tacın ödülü seni bekliyor."
    }
  },
  "quests": {
    "boar_cull": {
      "name": "Şalgam Tarlasında Dişler",
      "text": "Kıllı yaban domuzları köyün etrafındaki bütün tarlaları eşeliyor. Sayılarını azalt."
    },
    "grey_pelts": {
      "name": "Gri Postlar",
      "text": "Tabakçı soğuklar başlamadan kül kurdu postu istiyor."
    },
    "mire_toads": {
      "name": "Bataklıkta Vıraklama",
      "text": "Bataklık kurbağaları bataklıktan yola taşmış. Onları geri püskürt."
    },
    "husk_hearts": {
      "name": "Taştan Kalpler",
      "text": "Taş kabukların içinde sıcak bir taş var. İncelemek için birkaç tane getir."
    },
    "thornbacks": {
      "name": "Dikensırt Belası",
      "text": "Dikensırt domuzlar iki tarla işçisini boynuzladı. Bu işe bir son ver."
    },
    "road_tax": {
      "name": "Yol Vergisi",
      "text": "Haydutlar yoldaki her arabayı soyuyor. Çaldıklarını geri al."
    },
    "pack_leaders": {
      "name": "Sürü Liderleri",
      "text": "Alfaları olmadan kurt sürüleri dağılır."
    },
    "lurker_eyes": {
      "name": "Sudaki Gözler",
      "text": "Bataklık pusucularının gözleri karanlıkta parlar. Simyacı bunlara para veriyor."
    },
    "barrow_rest": {
      "name": "Höyüklere Huzur",
      "text": "Ölüler geceleri eski höyüklerden çıkıyor. Onları yeniden uykuya gönder."
    },
    "bear_country": {
      "name": "Ayı Diyarı",
      "text": "Mağara ayıları çiftliklere inmiş. Kış gelmeden onları avla."
    },
    "bear_claws": {
      "name": "Tabakçıya Pençe",
      "text": "Mağara ayısı pençelerinden en iyi kancalar ve tılsımlar yapılır."
    },
    "troll_hunt": {
      "name": "Trol Avı",
      "text": "Orman trolleri oduncu kamplarını yağmalıyor."
    },
    "troll_hides": {
      "name": "Yosunlu Postlar",
      "text": "Trol postu kılıcı durdurur. Zırhçılar bulabildikleri her şeyi istiyor."
    },
    "stone_giants": {
      "name": "Taş Devler",
      "text": "Granit golemler taş ocağı yolunu kapatıyor. Onları parçala."
    },
    "golem_cores": {
      "name": "Canlı Kaya",
      "text": "Golemleri bir şey hareket ettiriyor. Çekirdeklerinin kırıklarını getir."
    },
    "dire_nights": {
      "name": "Vahşi Geceler",
      "text": "Vahşi kurtlar karanlık çökünce yollarda avlanıyor. Önce sen onları avla."
    },
    "dire_pelts": {
      "name": "Vahşi Postlar",
      "text": "Bir vahşi kurt postu nöbetçiyi bütün gece sıcak tutar."
    },
    "ogre_menace": {
      "name": "Ogre Tehdidi",
      "text": "Kaba ogreler diyarın kenarında toplanıyor. Onları dağıt."
    },
    "ogre_totems": {
      "name": "Savaş Totemleri",
      "text": "Her ogre çetesi bir savaş totemi taşır. Totemleri al, çeteler cesaretini yitirsin."
    },
    "ashes": {
      "name": "Külden Küle",
      "text": "Kül hortlakları Koloni'nin yanık topraklarından yükseliyor. Onları yere ser."
    },
    "grave_embers": {
      "name": "Mezar Közleri",
      "text": "Bir hortlağın içindeki közler hâlâ yanıyor. Birkaçını sağlam getir."
    },
    "pit_hounds": {
      "name": "Çukurun Tazıları",
      "text": "Cehennem tazıları Koloni'de sürü halinde dolaşıyor. Sürüleri seyrelt."
    },
    "brimstone_fangs": {
      "name": "Kükürt Dişler",
      "text": "Cehennem tazısı dişleri dokununca yakar. Demirciler ocak için istiyor."
    },
    "black_glass": {
      "name": "Kara Cam",
      "text": "Obsidyen golemler cam tarlalarını koruyor. Aralarından yol aç."
    },
    "obsidian_shards": {
      "name": "Obsidyen Kırıkları",
      "text": "Keskin obsidyenden iyi ok ucu olur. Kırılmamış parçalar getir."
    },
    "cinder_wardens": {
      "name": "Kor Muhafızları",
      "text": "Kor muhafızları yanan harabelerde nöbet tutuyor. Onları biç."
    },
    "warden_sigils": {
      "name": "Muhafız Mühürleri",
      "text": "Her muhafız eski ateşin mührünü taşır. Onları al."
    },
    "molten_giants": {
      "name": "Erimiş Devler",
      "text": "Magma devleri lav tarlalarından sürünerek çıkıyor. Onları durdur."
    },
    "gloom_eyes": {
      "name": "Kasvetteki Avcılar",
      "text": "Kasvet avcıları karanlıkta görür. Gözleri bir servet eder."
    },
    "nation_war": {
      "name": "Taç İçin Kan",
      "text": "Koloni Bölgesi'nde karşı ulustan 100 savaşçıyı yen. Partindeki herkesin öldürdükleri herkese sayılır."
    }
  },
  "store": {
    "wings_dawn": "Şafaktüyü Kanatları",
    "wings_seraph": "Melek Kanatları",
    "wings_sovereign": "Hükümdar Kanatları",
    "wings_aurelian": "Altın Kanatlar",
    "wings_ember": "Köz Ejderi Kanatları",
    "wings_phoenix": "Anka Kanatları",
    "wings_nightshade": "Gece Gölgesi Kanatları",
    "wings_moon": "Ay Tülü Kanatları",
    "wings_frost": "Ayaz Tülü Kanatları",
    "skin_crimson": "Kızıl Şövalye",
    "skin_frost": "Ayaz Muhafızı",
    "skin_gilded": "Yaldızlı Hükümdar",
    "skin_shadow": "Gölge Avcısı",
    "skin_storm": "Fırtına Çağıran",
    "glow_azure": "Mavi Işık Ruhu",
    "glow_solar": "Güneş Işık Ruhu",
    "glow_ember": "Köz Işık Ruhu",
    "glow_verdant": "Yeşil Işık Ruhu",
    "glow_violet": "Mor Işık Ruhu",
    "glow_prism": "Prizma Işık Ruhu",
    "fortune_stone_1": "Şans Taşı",
    "fortune_stone_10": "Şans Taşı x10",
    "premium_30": "Gold Premium, 30 gün",
    "market_scroll_30": "Pazar Kağıdı, 30 gün",
    "cloak_lionheart": "Aslanyürek Mantosu",
    "cloak_starweave": "Yıldız Dokuma Pelerin",
    "cloak_emberwake": "Köz İzi Pelerini",
    "cloak_wildheart": "Yabanyürek Mantosu"
  },
  "structures": {},
  "pvpRanks": {
    "Skirmisher": "Akıncı",
    "Blooded": "Kan Görmüş",
    "Veteran": "Kıdemli",
    "Champion": "Şampiyon",
    "Paragon": "Efsane",
    "Sovereign": "Hükümdar",
    "Exalted": "Yüce",
    "Vanguard": "Öncü",
    "Warden": "Muhafız",
    "Sentinel": "Nöbetçi"
  },
  "wheelLabels": {
    "Mithril armor": "Mithril zırh",
    "Mithril weapon": "Mithril silah",
    "Dragon armor": "Ejder zırh",
    "Dragon weapon": "Ejder silah",
    "Unique jewel": "Eşsiz takı",
    "Unique weapon": "Eşsiz silah",
    "Legendary weapon": "Efsanevi silah",
    "Riftshard jewel": "Yarık Kırığı takısı",
    "Riftbound jewel": "Yarık Bağı takısı",
    "Rift regalia": "Yarık nişanları",
    "Level 55 weapon": "55. seviye silah",
    "Level 55 armor": "55. seviye zırh",
    "Steel armor": "Çelik zırh",
    "Steel weapon": "Çelik silah",
    "Silver jewel": "Gümüş takı",
    "Gold jewel": "Altın takı"
  }
}
